import {effectToggleSubMenuSearch} from './menu-effects'

// ADICIONA OU REMOVE CLASSE DE ALGUM SELETOR ALVO
export const menuToggleClass = (selector, choiceToggle, targetClass) => {
  if(typeof selector == 'string'){
    return [].forEach.call(document.querySelectorAll(selector), (el) => {
      el.classList[choiceToggle](targetClass)
    })
  }

  return selector.classList[choiceToggle](targetClass)
}

// Antes de abrir um subMenu, é necessário fechar o outro (caso exista algum aberto)
// Inclui valor "false", no aria-expanded
// Remove classe do Body
export const closeAllMenus = () => {
  const nodeList = document.querySelectorAll('.mdn-isActive')
  const bodyElement = document.querySelector('body')

  bodyElement.classList.remove('mdn-Menu-main-isActive', 'mdn-Menu-top-isActive', 'mdn-Menu-subMenu-isActive', 'mdn-Menu-notified-isActive')
  nodeList.forEach((el) => {
    el.classList.remove('mdn-isActive')
    menuExpandedAccessibility(el, 'remove')
  })

  // Remove Listener para Cortina (click fora do Menu)
  return menuClickOutSide('remove', helperToggleMenuState), menuClickOutSide('remove', effectToggleSubMenuSearch)
}

// EVENTOS DE CLICK
export const clickButtonEvent = (link, actionReturn) => {
  for (let i = 0, lgt = link.length; i < lgt; i++) {
    link[i].onclick = actionReturn
  }
}

// FUNCIONALIDADE aria-expanded
export const menuExpandedAccessibility = (el, toggleEvent) => {
  const toggleEventCondional = toggleEvent == 'add' ? true : false
  const getExpandedItem = el.querySelector('[aria-expanded="true"]')

  if(el.ariaExpanded) el.ariaExpanded = toggleEventCondional
  else if(getExpandedItem) getExpandedItem.ariaExpanded = toggleEventCondional
}

export const helperToggleMenuState = (event) => {
  if(event){
    const closestHeader = event.target.closest('.mdn-Menu')

    !closestHeader && closeAllMenus()
  }
}

export const menuClickOutSide = (eventListener, callBackFuncion) => {
  window[eventListener+'EventListener']('click', callBackFuncion, true)
}

export const toggleHighContrast = () => {
  !window.setThemeButton('contrast')
}


